import { MotorsMetadata } from './metadata';
import { ValidationResult } from './validation-result';

export interface MotorsDraft {
    id: number;
    categoryId: number;
    status: number;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    draftData: any;
    originalDraftData?: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    validationSchema: any;
    metadata: MotorsMetadata;
    validationResults: ValidationResult[];
}
